export const ACCEPTED_FILE_TYPES = [
  "pdf",
  "doc",
  "fdx",
  "docx",
  "pptx",
  "rtf",
  "mp4",
  "jpg",
  "ppt",
  "jpeg",
  "png",
  "msg",
  "mov",
  "ppsx",
  "odt",
  "tiff",
  "xlsm",
  "xlsx",
  "wav",
  "m4v",
  "mp3",
  "dotx",
  "txt",
  "mpeg",
  "pages",
  "pptm",
  "ogg",
  "potx",
];

export const VIEWABLE_FILE_TYPES = [
  "pdf",
  "doc",
  "docx",
  "jpg",
  "mp4",
  "jpeg",
  "png",
  "mp3",
  "txt",
  "mpeg",
  "wav",
  "ogg",
];

export const USER_ROLES = [
  "DRAMATURGY",
  "VARIETY",
  "RESEARCH",
  "GOVERNANCE",
  "TECHNOLOGY",
  "ADMIN",
  "ANALYST",
  "TEXTRELEASE",
  "CHANNEL",
  "EXTERNALPROJECT",
  "ATTACHMENTVIEWER",
];
